module.exports = __webpack_public_path__ + "img/Empty-state.8b7eaed8.svg";